import { getGlobal } from "../lib/get-global";
import { StorageNoop } from "../lib/storage";
import { Metadata, Primitive } from "./metadata";
import { Sdk } from "./sdk";

export type Beacon = ReturnType<typeof createBeaconPlugin>;

export interface BeaconOptions {
  type: string;
  data: {
    sourceUrl: string;
    referrer: string;
    [key: string]: Primitive;
  };
}

export function createBeaconPlugin(sdk: Sdk, metadata: Metadata) {
  const globalThis = getGlobal();
  let storage: Storage;
  if (
    typeof globalThis === "undefined" ||
    typeof sessionStorage === "undefined"
  ) {
    storage = StorageNoop;
  } else {
    storage = sessionStorage;
  }

  const REQUEST_ID_KEY = "spindl_request_id";

  let reqId = parseInt(storage.getItem(REQUEST_ID_KEY) ?? "0");

  function getRequestId() {
    const updatedValue = reqId + 1;
    storage.setItem(REQUEST_ID_KEY, updatedValue.toString());
    return reqId++;
  }

  async function sendBeacon<T extends { type: string } = BeaconOptions>(
    beacon: T
  ) {
    const headers: Record<string, string> = {
      "X-API-Key": sdk.getConfig().sdkKey,
    };

    const meta = await metadata.getMetadata();
    const reqId = getRequestId();

    const payload = {
      ...beacon,
      metadata: {
        version: sdk.version,
        ...meta,
        reqId,
      },
    };

    const response = await sdk.http.retrySend({
      url: `${sdk.getConfig().host}/events`,
      headers: {
        ...headers,
        "content-type": "application/json",
      },
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
    });

    if (response) {
      sdk.logger.info(`sent ${payload.type}`);
    }

    return Boolean(response);
  }

  return {
    sendBeacon,
  };
}
